module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('div', {
    class: {
      'full-v': _vm.appState.useCMS, 'full': !_vm.appState.useCMS
    }
  }, [(_vm.appState.useCMS) ? _c('Controllers', {
    on: {
      "api": function (v) {
        _vm.apis.controllers = v
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBigEnough) ? _c('div', {
    staticClass: "full"
  }, [_c('img', {
    staticClass: "mocker-title",
    attrs: {
      "src": require("./mocker/title.svg")
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mocker"
  }, [_c('div', {
    staticClass: "maxer"
  }, [_c('GLView', {
    on: {
      "refresh": function (v) {
        _vm.refresh.maxer1 = v
      },
      "glClick": _vm.passer
    }
  })], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "mocker-logo",
    attrs: {
      "src": require("./mocker/logo.svg")
    }
  })]) : _c('div', {
    staticClass: "mocker-mobile"
  }, [_c('div', {
    staticClass: "maxer"
  }, [_c('GLView', {
    on: {
      "refresh": function (v) {
        _vm.refresh.maxer1 = v
      },
      "glClick": _vm.passer
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146d15d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutHTML/Nike.vue
// module id = 576
// module chunks = 0